import {
    ROLES,
    PERMISSIONS
} from '@/config/permissions'

export default {
    data: function () {
        return {
            ROLES: ROLES,
            PERMISSIONS: PERMISSIONS
        }
    },

    methods: {
        hasRole(roleName) {
            // Check if role exsits in user roles
            if (this.$store.state.users.roles.length) {
                return this.$store.state.users.roles.includes(roleName);
            }
            return false
        },

        can(perm, authorID = false) {
            // If user is admin or
            // If authorID id is equal to current userId
            // the permission is always granted
            if (this.hasRole(ROLES.ADMINS) || this.$store.state.users.user.id == authorID) {
                return true;
            }

            // Check if permission exsits in user permissions
            if (this.$store.state.users.permissions.length) {
                return this.$store.state.users.permissions.includes(perm);
            }
            return false;
        }
    }
}
